import { Pipe, PipeTransform } from '@angular/core';
import { AvanoButtonBarButtonUtils } from './avano-button-bar-button.util';

@Pipe({
  name: 'avanoButtonBarLabel'
})
export class AvanoButtonBarLabelPipe implements PipeTransform {
  transform(fullLabel: string): string {
    return AvanoButtonBarButtonUtils.splitLabelEquallish(fullLabel)
      .map((partOfTheLabel: string) => {
        return '<div>' + partOfTheLabel + '</div>';
      })
      .reduce((firstPart, secondPart) => firstPart + secondPart);
  }
}
